<template>
  <div class="mobile-nav-bar">
    <div class="mobile-nav-title">{{title}}</div>
    <button class="mobile-nav-left-button" @click.prevent="leftButtonClicked">
      <i class="fas fa-chevron-left" v-if="hasPrevious"></i>
      <i class="fas fa-bars" v-if="!hasPrevious"></i>
    </button>

    <button class="mobile-nav-right-button" data-toggle="dropdown" v-if="actionMenu">
      <div class="mobile-nav-right-button-alert" v-if="actionDisplayNotification" />
      <i class="far fa-ellipsis-v"></i>
    </button>
    <ul class="dropdown-menu dropdown-menu-right" v-if="actionMenu">
      <slot name="actionMenu" />
    </ul>
  </div>
</template>


<script>
export default {
  name: 'MobileNavBar',
  props: {
    title: String,
    backButtonLink: String,
    actionMenu: Boolean,
    actionDisplayNotification: Boolean
  },
  computed: {
    hasPrevious() {
      return this.backButtonLink != null
    }
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    leftButtonClicked(evt) {
      if(this.hasPrevious) {
        // TODO: VueRouterBackButton module not working (has issue on GitHub about latest vue-router)
        // Handled via MobileLayout now

        this.$router.push({ path: this.backButtonLink, query: { back: true }})
      } else {
        this.$emit('drawerClick')
      }
    },
    onNativeAppMessage(ev) {
      if(ev.event == 'backButtonPressed') {
        this.$nextTick(() => {
          this.leftButtonClicked()                    
        })
      }
    },
  }
}
</script>